import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { changePpiTableItem } from '../actions';
import TextField from 'material-ui/TextField';

class PPITableRowColumnInput extends Component {
    state = {
        value: this.props.value || 10
    };

    componentDidMount() {
        const { typePlayer = '', label = '', changePpiTableItem } = this.props;

        changePpiTableItem(typePlayer, label, parseInt(this.state.value, 10));
    }

    componentWillReceiveProps({ value }) {
        if (value != null && value !== this.state.value) {
            this.setState({ value });
        }
    }

    render() {
        const { typePlayer = '', label = '', changePpiTableItem } = this.props;
        const { value } = this.state;

        return (
            <TextField
                fullWidth
                type="number"
                value={value}
                hintText="Value..."
                onChange={(ev, newValue) => changePpiTableItem(typePlayer, label, parseInt(newValue, 10))}
            />
        );
    }
}

PPITableRowColumnInput.propTypes = {
    typePlayer: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    // From Connect
    value: PropTypes.number,
    changePpiTableItem: PropTypes.func.isRequired
};

export default connect(
    ({ ppi }, { typePlayer, label }) => ({
        value: ppi.playersWeights[typePlayer] && ppi.playersWeights[typePlayer][label]
    }),
    { changePpiTableItem }
)(PPITableRowColumnInput);



/** WEBPACK FOOTER **
 ** ../src/dash/front/ppi/components/PPITableRowColumnInput.js
 **/